import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SettingsService, MainPageSettings } from '../../shared/services/settings.service';

@Component({
  selector: 'app-settings-page',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    MatCheckboxModule, 
    MatCardModule, 
    MatIconModule, 
    MatButtonModule,
    MatSnackBarModule,
    TranslateModule
  ],
  templateUrl: './settingsPage.component.html',
  styleUrls: []
})
export class SettingsPageComponent implements OnInit {
  private _settingsService = inject(SettingsService);
  private _snackBar = inject(MatSnackBar);
  private _translateService = inject(TranslateService);
  
  title = 'Settings';
  settings: MainPageSettings = this._settingsService.getSettings();

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this.settings = this._settingsService.getSettings();
  }

  onSettingChange(settingKey: keyof MainPageSettings, value: boolean): void {
    this.settings[settingKey] = value;
    this._settingsService.updateSetting(settingKey, value);
    
    const message = this._translateService.instant('SETTINGS.SAVED');
    const action = this._translateService.instant('GLOBAL.CLOSE');
    
    this._snackBar.open(message, action, {
      duration: 2000,
      horizontalPosition: 'end',
      verticalPosition: 'bottom'
    });
  }

  resetToDefaults(): void {
    const defaultSettings: MainPageSettings = {
      showRecentNotifications: false,
      showQuickActions: false
    };
    
    this.settings = { ...defaultSettings };
    this._settingsService.saveSettings(this.settings);
    
    const message = this._translateService.instant('SETTINGS.RESET');
    const action = this._translateService.instant('GLOBAL.CLOSE');
    
    this._snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'bottom'
    });
  }
}